import { Props } from '~/containers/Vehicles';

const step = {
  route: '/homeowners-insurance/quotes/vehicles',
  breadcrumbStep: 'auto',
  isAccessible: ({ application }: Props): boolean => application.bundled || application.isAutoOnly,
};

export default step;
